<template>
  <VDatePicker
    v-model.string="date"
    :locale="locale"
    :min-date="minDate"
    :max-date="maxDate"
    :masks="{ modelValue: 'YYYY-MM-DD' }"
  >
    <template #default="{ togglePopover, inputValue, masks }">
      <form>
        <input
          readonly
          type="text"
          :placeholder="masks?.L"
          :value="inputValue"
          class="date-picker"
          @click="togglePopover"
        />
      </form>
    </template>
  </VDatePicker>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';

import dayjs from 'dayjs';

import { DATE_PICKER_LOCALE_MAP } from '@/static/languages';
import { useUserStore } from '@/stores/user';

const date = defineModel<string>({
  required: true,
  default: '',
});

withDefaults(
  defineProps<{
    minDate?: string;
    maxDate?: string;
  }>(),
  {
    minDate: '2025-01-01',
    maxDate: '2099-12-31',
  }
);

const userStore = useUserStore();

const locale = computed<string>(() => {
  return DATE_PICKER_LOCALE_MAP[userStore.pageLanguage] || userStore.pageLanguage;
});

const today = computed<string>(() => {
  return dayjs().format('YYYY-MM-DD');
});

onMounted(() => {
  if (!date.value) {
    date.value = today.value;
  }
});
</script>

<style scoped lang="scss">
.date-picker {
  color: var(--font-default);
}
</style>
